import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'ramda/src/isNil';

function Icon({
    name = 'fas fa-bell',
    active = false,
    color = null,
    size = 12,
    colors = ['#376caf', '#d3d3d3'],
    style = {},
    onClick = () => {},
    onMouseEnter = () => {},
    onMouseLeave = () => {},
    dataCy,
    ...props
}) {
    let iconColor;
    if (isNil(color)) {
        iconColor = active ? colors[0] : colors[1];
    } else {
        iconColor = color;
    }
    const styles = {
        ...style,
        color: iconColor,
        fontSize: size,
    };

    // Todo: Remove this component and replace with FaIcon
    // if (window.location.hostname === 'localhost') {
    //     console.trace('Use of deprecated Icon component. Please use FaIcon instead.');
    // }

    return (
        <i
            className={name}
            data-cy={dataCy}
            style={styles}
            onClick={() => onClick && onClick()}
            onMouseEnter={() => onMouseEnter && onMouseEnter()}
            onMouseLeave={() => onMouseLeave && onMouseLeave()}
            {...props}
        />
    );
}

Icon.propTypes = {
    name: PropTypes.string,
    active: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    color: PropTypes.string,
    size: PropTypes.number,
    style: PropTypes.object,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    colors: PropTypes.array,
    dataCy: PropTypes.string,
};

export default Icon;
